export const AnalyticsLocalStorageKeys = {
  RefContextType: "ref_ctx_type",
  RefContextIndex: "ref_ctx_index",
  RefContextLabel: "ref_ctx_label",
  RefListID: "ref_list_id",
  RefListIndex: "ref_list_index",
};

export const AnalyticsContextTypes = {
  // Colourful pills at top and bottom of SRP. AKA "Discovery Bubbles"
  TopicPill: "topic-pill",
  // Non-coloured pills with heading Related Search.
  RelatedSearchPill: "related-search-pill",
  // Category pill rendered midst search results in a carousel.
  CategoryPill: "category-pill",
  // Any of the category, price, size, medium filters.
  Filter: "filter",
  // Change in sort order
  SortOrder: "sort-order",
  TrendingTypeahead: "trending-typeahead",
  PopularTypeahead: "popular-typeahead",
  RecentTypeahead: "recent-typeahead",
  FallbackTypeahead: "fallback-typeahead",
  CategoriesTypeahead: "categories-typeahead",
  ArtistsTypeahead: "artists-typeahead",
  SearchBox: "search-box",
};

export const AnalyticsItemsList = {
  ArtistDesignResults: "artist_design_results",
  ArtistShopResults: "artist_shop_results",
  FeaturedCollection: "featured_collection",
  SearchResultsPageResults: "srp_results",
  SimilarProductsCarousel: "similar_products_carousel",
  TrendingProductsCarousel: "trending_products_carousel",
  InventoryItemsCarousel: "inventory_items_carousel",
  ProductCarousel: "product_carousel",
  TabbedList: "tabbed_list",
  TagsCarousel: "tags_carousel",
  ProductGrid: "product_grid",
  Recommendations: "recommendations",
  UserList: "user_list",
};

export const AnalyticsItemsListIDNameMap = {
  artist_design_results: "Artist Design Results",
  artist_shop_results: "Artist Shop Results",
  featured_collection: "Featured Collection",
  similar_products_carousel: "Similar Products Carousel",
  srp_results: "SRP Results",
  trending_products_carousel: "Trending Products Carousel",
  inventory_items_carousel: "Inventory Items Carousel",
  product_carousel: "Product Carousel",
  tabbed_list: "Tabbed List",
  tags_carousel: "Tags Carousel",
  product_grid: "Product Grid",
  recommendations: "Recommendations",
  user_list: "User List",
};

export const ANALYTICS_SRP_FALLBACK_PAGE_SIZE = 108;
export const ANALYTICS_ARTIST_SHOP_FALLBACK_PAGE_SIZE = 100;
